/* eslint-disable prettier/prettier */
export const herbFilter = () => {
  // Precompute whether articles exist for each letter
  const letterHasArticles = {};

  const hrgFilterSection = document.getElementById('hrg-filter-section');

  let herbs = document.querySelectorAll('.herb-item');
  let allLetters = 'abcdefghijklmnopqrstuvwxyz'.split('');

  // Check if herbs and letters exist before proceeding
  if (herbs.length === 0) {
    return;
  }

  const letters = document.querySelectorAll('[data-letter]');
  if (letters.length === 0) {
    return;
  }

  // Initialize the letterHasArticles mapping
  allLetters.forEach((letter) => {
    letterHasArticles[letter] = Array.from(herbs).some(function (herb) {
      return herb.getAttribute('data-first-letter') === letter;
    });
  });

  // Set default filter to 'A' on page load if 'A' has articles
  filterByLetter('a', false);

  // Add event listeners for each letter
  letters.forEach((letter) => {
    const letterText = letter.getAttribute('data-letter').toLowerCase();
    if (!letterText) {
      return;
    }
    if (letterText !== 'all' && letterHasArticles[letterText]) {
      letter.addEventListener('click', () => filterByLetter(letterText));
    }
  });

  // Add event listener for the "Show All" option
  const showAllLetters = document.querySelectorAll('[data-letter="All"]');
  if (showAllLetters.length == 0) {
    return;
  }
  if (showAllLetters.length > 0) {
    showAllLetters.forEach((showAllLetter) => {
      showAllLetter.addEventListener('click', () => filterByLetter('all'));
    });
  }

  function filterByLetter(selectedLetter, scrollToSection = true) {
    const selectedLetterElement = document.querySelector('.selected-letter');
    if (!selectedLetterElement) {
      return;
    }
    selectedLetterElement.innerText = selectedLetter.toUpperCase();

    if (herbs.length === 0) {
      return;
    }

    herbs.forEach((herb) => {
      const herbFirstLetter = herb.getAttribute('data-first-letter');
      if (!herbFirstLetter) {
        return;
      }

      // Show all herbs if 'Show All' is clicked, otherwise filter by the selected letter
      if (selectedLetter === 'all' || herbFirstLetter === selectedLetter) {
        herb.classList.remove('hidden'); // Show matching herbs
        herb.classList.add('block');
      } else {
        herb.classList.remove('block'); // Remove display block
        herb.classList.add('hidden');
      }
    });

    letters.forEach((letter) => {
      const letterText = letter.getAttribute('data-letter').toLowerCase();
      const hasArticles = letterHasArticles[letterText];

      if (!letterText) {
        return;
      }

      if (letterText === selectedLetter) {
        letter.classList.remove('text-lime-950', 'underline');
        letter.classList.add('text-beige-950');
      } else if (!hasArticles) {
        letter.classList.remove('text-beige-950', 'underline', 'text-lime-950');
        letter.classList.add('text-gray-500', 'no-underline');
        letter.style.cursor = 'default'; // Disable cursor for letters with no articles
      } else {
        letter.classList.remove('text-beige-950', 'no-underline', 'text-gray-500');
        letter.classList.add('underline', 'text-lime-950');
        letter.style.cursor = 'pointer'; // Enable pointer cursor for clickable letters
      }

      // Handle "Show All" separately
      if (letterText === 'all') {
        letter.style.cursor = 'pointer';
        if (selectedLetter === 'all') {
          letter.classList.remove('text-lime-950', 'underline');
          letter.classList.add('text-beige-950');
        } else {
          letter.classList.remove('text-gray-500', 'no-underline', 'text-beige-950');
          letter.classList.add('text-lime-950', 'underline');
        }
      }
    });

    if (scrollToSection && hrgFilterSection) hrgFilterSection.scrollIntoView({ behavior: 'smooth' });
  }
};
